// extracted by mini-css-extract-plugin
export var defaultWrapper = "_fh-3";
export var downloadButton = "_fh-4";
export var fileContainer = "_fh-9 _fh-7";
export var fileContainerBase = "_fh-7";
export var fileContainerBaseSm = "_fh-a _fh-7";
export var fileContainerFixedHeight = "_fh-8 _fh-7";
export var fileContainerFixedHeightSm = "_fh-c _fh-a _fh-7";
export var fileContainerSm = "_fh-b _fh-a _fh-7";
export var fileInfo = "_fh-5";
export var fileInfoWidthRestricted = "_fh-6";
export var fileType = "_fh-1";
export var fileTypeName = "_fh-2";
export var fileTypeSm = "_fh-d _fh-1";
export var image = "_fh-0";
export var link = "_fh-f";
export var overflowEllipsis = "_fh-e";